module.exports = __webpack_public_path__ + "static/media/Call settings.67823575.svg";